import React from 'react';
import { Link } from 'react-router-dom';
import { getFavoriteIcon } from '../../../components/Icons/SeasonalIcons';
import { useTilesStore } from '../../tiles.store';
import './sip-tile.css';

export const SipTile = ({ linkTo, title, description, imgSource }) => {
  const { toggleFavorite, isFavorite } = useTilesStore();

  const handleToggleFavorite = (e: { preventDefault: () => void; stopPropagation: () => void }) => {
    e.preventDefault();
    e.stopPropagation();
    toggleFavorite(linkTo);
  };

  return (
    <Link to={linkTo} className="neo-sip-tile">
      <div className="favorite-toggle" onClick={handleToggleFavorite}>
        {getFavoriteIcon(!isFavorite(linkTo))}
      </div>
      <div className="neo-sip-tile-container">
        <img src={imgSource} alt="icon" />
        <div className="neo-tile-info">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </div>
    </Link>
  );
};
